import { isOnlyDigits } from './num';

type CodeValidatorConfig = {
  size: number;
  exact?: boolean; // exact=true => length === size, else length <= size
};

type CodeValidatorOptions = {
  allowEmpty?: boolean;
};

type CodeValidatorResult = { success: true; data: string } | { success: false };

export class CodeValidator {
  private size: number;
  private exact: boolean;

  constructor(config: CodeValidatorConfig) {
    this.size = config.size;
    this.exact = config.exact ?? false;
  }

  validate(value: unknown, options: CodeValidatorOptions = {}): CodeValidatorResult {
    const { allowEmpty } = options;

    if (typeof value !== 'string') {
      return { success: false };
    }

    if (this.exact) {
      if (value.length !== this.size) {
        return { success: false };
      }
    } else if (value.length > this.size) {
      return { success: false };
    }

    if (!isOnlyDigits(value, allowEmpty)) {
      return { success: false };
    }

    return { success: true, data: value };
  }

  static exactLength(size: number) {
    return new CodeValidator({ size, exact: true });
  }

  static maxLenght(size: number) {
    return new CodeValidator({ size, exact: false });
  }
}
